import React from "react"
import { css } from "@jsUtils"

import Styles from "./eyebrow.module.scss"

/**
 * Eyebrow with colored line
 * @param {object} props - react props
 * @param {string} props.color - line color
 * @param {object} props.children - child components
 * @param {string} props.className - class name
 * @param {string} props.style - inline css styles
 * @param {boolean} props.wrap - should text wrap or not
 */

const Eyebrow = props => {
  const { children, color, wrap, className, style } = props
  return (
    <div
      className={css(Styles.eyebrow, color && Styles[color], wrap && Styles.wrap, className)}
      style={style}
    >
      {children}
    </div>
  )
}

export default Eyebrow
